import { GroupByTransformPlainObject } from './groupByTransform.plainObject';
import { SortExpressionPlainObject } from './sortExpression.plainObject';

export class WindowPlainObject extends GroupByTransformPlainObject {
    public sortColumns: SortExpressionPlainObject[] = [];
}
